import CookieService from "./CookieService";

export default class ToastService {
    static addSuccessMessage(title, message) {
        return CookieService.setCookieWithServer('toast', JSON.stringify({title, message, type: 'success'}));
    }

    static addErrorMessage(title, message) {
        CookieService.setCookieWithServer('toast', JSON.stringify({title, message, type: 'error'}));
    }
}